import './Benefits.css';const benefits = "_benefits_ovsxs_1";
const styles = {
  benefits
};
export {
  benefits,
  styles as default
};
